import AssetsPack from "./AssetsPack";

const StylePack = {
  BACKGROUND_LOGIN_STYLE: {
    backgroundImage: `url(${AssetsPack.backgrounds.BACKGROUND_LOGIN})`,
    backgroundSize: `cover`,
    backgroundPosition: `center`,
    backgroundRepeat: `no-repeat`,
  },
  BACKGROUND_FOOTER_WITHDRAW_STYLE: {
    backgroundImage: `url(${AssetsPack.backgrounds.FOOTER_CARD_BACKGROUND_WITHDRAW})`,
    backgroundSize: `cover`,
    backgroundPosition: `center`,
    backgroundRepeat: `no-repeat`,
  },
  BACKGROUND_FOOTER_DEPOSIT_STYLE: {
    backgroundImage: `url(${AssetsPack.backgrounds.FOOTER_CARD_BACKGROUND_DEPOSIT})`,
    backgroundSize: `cover`,
    backgroundPosition: `center`,
    backgroundRepeat: `no-repeat`,
  },
  BACKGROUND_FOOTER_GET_STARTED: {
    backgroundImage: `url(${AssetsPack.backgrounds.FOOTER_CARD_BACKGROUND_GET_STARTED})`,
    backgroundSize: `cover`,
    backgroundPosition: `center`,
    backgroundRepeat: `no-repeat`,
  }
};

export default StylePack;
